package com.dotdrives.web.pages.giving

import com.dotdrives.model.*
import kotlinx.serialization.json.*
import react.FC
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.datalist
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.form
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.strong
import web.cssom.ClassName

internal val GivingEmployerMatch =
    FC<GivingSectionProps> { props ->
        val state = props.state
        val controller = props.controller
        val form = state.form ?: return@FC
        div {
            className = ClassName("give-matching")
            strong { +"Employer matching" }
            if (form.config.employerMatches.isEmpty())
                p {
                    +"Employer lookup is not available for this campaign. You can ask your employer about matching after giving."
                }
            else {
                label {
                    className = ClassName("give-field")
                    span { +"Employer (optional)" }
                    input {
                        value = state.employer
                        list = "give-employers"
                        onChange = { controller.setEmployer(it.currentTarget.value) }
                    }
                }
                datalist {
                    id = web.dom.ElementId("give-employers")
                    form.config.employerMatches.forEach { option { value = it.employer } }
                }
                val match = state.match
                if (match == null)
                    p {
                        +"Choose your employer or use your work email to check the organization’s listed programs. Matching never changes your gift amount."
                    }
                else {
                    p {
                        +"${match.employer} may match your gift. Eligibility must be confirmed with your employer."
                    }
                    p { +match.instructions }
                    match.url?.takeIf(::safeGivingUrl)?.let { url ->
                        a {
                            href = url
                            target = "_blank".unsafeCast<web.window.WindowTarget>()
                            rel = "noopener noreferrer"
                            +"View employer instructions ↗"
                        }
                    }
                }
            }
        }
    }
